/// <reference types="vite-plugin-svgr/client" />
import React from "react";

import { AnimationOnScroll } from "react-animation-on-scroll";
import { Col, Container, Row } from "react-bootstrap";

import faAffordable from "@/assets/icons/faAffordable.svg";
import faEnergyEfficient from "@/assets/icons/faEnergyEfficient.svg";
import faSpeedyConstruction from "@/assets/icons/faSpeedyConstruction.svg";
import faSustainableHome from "@/assets/icons/faSustainableHome.svg";
import { getCurrentLang } from "@/utils/Local";

import i18n from "../../i18n";

const IntroScreen: React.FC = () => {
  const { t } = i18n;
  const percentage = getCurrentLang() === "fr" ? " %" : "%";
  const reasons = [
    {
      icon: <img alt={t("Sustainable")} src={faSustainableHome} />,
      title: t("Sustainable"),
      value: `100${percentage}`,
      note: t("recycled plastic bottles"),
    },
    {
      icon: <img alt={t("Speedy Construction")} src={faSpeedyConstruction} />,
      title: t("Speedy Construction"),
      value: `10X`,
      note: t("faster"),
    },
    {
      icon: <img alt={t("Affordable")} src={faAffordable} />,
      title: t("Affordable"),
      value: `35${percentage}`,
      note: t("less expensive"),
    },
    // {
    //   icon: <img alt={t("Long-Lasting")} src={faLongLasting} />,
    //   title: t("Long-Lasting"),
    //   note: t("years life expectancy"),
    //   value: "400+",
    // },
    {
      icon: <img alt={t("Energy Efficient")} src={faEnergyEfficient} />,
      title: t("Energy Efficient"),
      note: t("more energy-efficient"),
      value: `15${percentage}`,
    },
  ];

  return (
    <Container fluid className="screenContainer introContainer p-0 mt-4 mb-4">
      <Container className="flexContainer">
        {/* <Row className="w-100"> */}
        {/*  <Col xs={12}> */}
        {/*    <h2 className="text-center text-lg-start"> */}
        {/*      {t("Why Choose PakVille")}? */}
        {/*    </h2> */}
        {/*  </Col> */}
        {/* </Row> */}
        {/* <div className=" horizontal-content-container"> */}
        {/*  {reasons.map((reason) => ( */}
        {/*    <div key={reason.title} className="pakvilleReasonContainer"> */}
        {/*      {reason.icon} */}
        {/*      <h3>{reason.title}</h3> */}
        {/*      <p> */}
        {/*        <span>{reason.value}</span>&nbsp; */}
        {/*        <span>{reason.note}</span> */}
        {/*      </p> */}
        {/*    </div> */}
        {/*  ))} */}
        {/* </div> */}

        <Row className="w-100 pt-2 pb-2 mt-2 mt-lg-0">
          <Col className="mt-4 mt-lg-0 order-2 order-lg-1" lg={6} xs={12}>
            <AnimationOnScroll animateOnce animateIn="animate__fadeInLeftBig">
              <div className="ratio ratio-16x9 text-center mt-4 mb-4 ">
                <iframe
                  allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  className="embed-responsive-item w-100 rounded"
                  height="315"
                  src="https://www.youtube.com/embed/cpY9jRhW46M?si=IOLCXJfwMEUIczOU"
                  title="YouTube video player"
                  width="560"
                />
              </div>
            </AnimationOnScroll>
          </Col>
          <Col className="order-1 order-lg-2 ps-0 ps-lg-5" lg={6} xs={12}>
            <div className="flexContainer introContent" style={{ gap: "35px" }}>
              <h2>{t("Why Choose PakVille")}?</h2>
              <div className="horizontal-content-container">
                {reasons.map((reason) => (
                  <div key={reason.title} className="pakvilleReasonContainer">
                    {reason.icon}
                    <h3>{reason.title}</h3>
                    <p>
                      <span>{reason.value}</span>&nbsp;
                      <span>{reason.note}</span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default IntroScreen;
